import { render, staticRenderFns } from "./EcoAIBigData.vue?vue&type=template&id=9cfda686&"
import script from "./EcoAIBigData.vue?vue&type=script&lang=js&"
export * from "./EcoAIBigData.vue?vue&type=script&lang=js&"
import style0 from "./EcoAIBigData.vue?vue&type=style&index=0&id=9cfda686&prod&lang=scss&"
import style1 from "./EcoAIBigData.vue?vue&type=style&index=1&id=9cfda686&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports